import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading } from "./SectionHeading";
import { FAQS } from "@/data/content";

export const FAQ = () => (
  <section id="faq" className="cd-section border-t border-[#bdbdb4]" data-testid="faq-section">
    <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
      <SectionHeading id="faq" title="FAQ" />
      <div className="cd-reveal mt-12 grid lg:grid-cols-12">
        <Accordion type="single" collapsible className="border-t border-[#bdbdb4] lg:col-span-8" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i + 1}`} className="border-b border-[#bdbdb4]" data-testid={`faq-item-${i + 1}`}>
              <AccordionTrigger
                className="cd-faq-trigger gap-6 py-6 text-left font-display text-lg font-medium text-[#292929] hover:no-underline sm:text-xl"
                data-testid={`faq-trigger-${i + 1}`}
              >
                <span className="flex items-baseline gap-4">
                  <span className="font-mono text-xs text-[#ff6600]">{String(i + 1).padStart(2, "0")}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-9 pr-8 text-[15px] leading-relaxed text-[#55554f]" data-testid={`faq-answer-${i + 1}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
